{
  "account_is_inactive": "A sua conta está desativada.",
  "addons_email_marketing": "Email marketing",
  "addons_email_marketing_description": "Crie newsletters, envie campanhas direcionadas e analise os resultados. Organize seus contatos em listas e segmentos. Aumente sua lista de assinantes com formulários de inscrição e escolha entre centenas de modelos responsivos.",
  "addons_email_marketing_lower": "<p>Inscreva-se para:</p><ul><li><strong>Criar</strong>, <strong>enviar</strong> e <strong>analisar</strong> campanhas direcionadas</li><li>Organizar seus <strong>contatos em listas</strong> e <strong>segmentos específicos</strong></li><li>Aumentar sua lista de assinantes usando <strong>formulários de inscrição</strong>, <strong>pop-up</strong> ou <strong>formulários inline</strong> em seu site</li><li>Acessar a mais de <strong>700 modelos gratuitos</strong>, organizados por categoria e totalmente responsivos</li><li>Tudo em <strong>conformidade com a Lei CAN-SPAM</strong> e o <strong>GDPR</strong></li></ul><p><a href=\"https://emailchef.com/features/\" target=\"_blank\">Saiba mais</a> sobre nosso serviço de e-mail marketing.</p>",
  "addons_email_marketing_tryitforfree": "Inicie seu Teste Grátis",
  "addons_email_marketing_upper": "<p>Crie campanhas de email marketing com um serviço de email profissional e fácil de usar. Os servidores TurboSMTP garantem <strong>as melhores taxas de entrega em cumprimento da GDPR</strong>.<p>",
  "addons_email_validator": "Validador de Email",
  "addons_email_validator_description": "Um ficheiro carregado deve conter apenas um endereço de e-mail em cada linha. Os formatos de ficheiro permitidos são csv e txt. Ou selecione um ficheiro para carregar.",
  "addons_emailmarketing_title": "Email marketing",
  "addons_title": "Addons",
  "analytics_average_click": "Atraso médio do clique",
  "analytics_average_click_description": "Tempo médio decorrido entre a abertura e o clique",
  "analytics_average_first": "Atraso médio na primeira abertura",
  "analytics_average_first_description": "Tempo médio decorrido entre a entrega e a abertura",
  "analytics_average_opens": "Taxa média de abertura de e-mail",
  "analytics_average_opens_description": "Número médio de vezes que um e-mail foi aberto.",
  "analytics_chart_frequency_d": "Diariamente",
  "analytics_chart_frequency_h": "A cada hora",
  "emailvalidator_validate_freecredits_used": "Os seguintes créditos gratuitos serão usados:",
  "analytics_chart_frequency_m": "Mensalmente",
  "analytics_chart_frequency_w": "Semanalmente",
  "analytics_charts": "Gráficos",
  "analytics_clicks_title": "Sem cliques",
  "analytics_date": "Data",
  "analytics_description_clicks_empty": "Nenhum dado de clique encontrado..",
  "analytics_description_empty": "Não existem dados para o período selecionado.",
  "analytics_event_bounce": "Devolvido",
  "analytics_event_clicks": "Clicado",
  "analytics_event_delivered": "Entregado",
  "analytics_event_drop": "Rejeitado",
  "analytics_event_opens": "Aberto",
  "analytics_event_queued": "Em espera",
  "analytics_event_sent": "Entregado",
  "analytics_event_spam": "Spam",
  "analytics_event_unsubscribes": "Desinscrito",
  "analytics_events": "Eventos",
  "analytics_events_all": "Tudo",
  "analytics_events_bounce": "Devolvido",
  "analytics_events_bounce_tooltip": "A porcentagem e o número de e-mails devolvidos pelos servidores de seus destinatários.",
  "analytics_events_bounces": "Devolvidos",
  "analytics_events_clicks": "Clicado",
  "analytics_events_clicks_tooltip": "A percentagem e número de pessoas que clicaram em pelo menos um link incluído na sua mensagem.",
  "analytics_events_delivered": "Entregue",
  "analytics_events_delivered_tooltip": "A porcentagem e o número de mensagens enviadas entregues com sucesso.",
  "analytics_events_drop": "Rejeitados",
  "analytics_events_drop_tooltip": "Esses e-mails são excluídos porque foram cancelados anteriormente, devolvidos ou marcados como spam. Os e-mails rejeitados são encontrados na seção Supressões.",
  "analytics_events_opens": "Aberto",
  "analytics_events_opens_tooltip": "A percentagem e o número de e-mails abertos pelos seus destinatários.",
  "analytics_events_queued": "Em espera",
  "analytics_events_queued_tooltip": " A porcentagem do total de e-mails que ainda estão na fila de entrega.",
  "analytics_events_sent": "Entregue",
  "analytics_events_spam": "Spam",
  "analytics_events_spam_tooltip": "A porcentagem de destinatários que denunciaram sua mensagem como spam.",
  "analytics_events_unsubscribes": "Desinscritos",
  "analytics_events_unsubscribes_tooltip": "A porcentagem de solicitações de cancelamento de inscrição resultantes de mensagens entregues com sucesso.",
  "analytics_file": "Nome do ficheiro",
  "analytics_filterby_domain": "Domínio",
  "analytics_filterby_recipient": "Destinatário",
  "analytics_filterby_sender": "Remetente",
  "analytics_filterby_subject": "Assunto",
  "analytics_numbers": "Números",
  "analytics_openclick": "Análise de aberturas/cliques",
  "analytics_overview": "Visão geral",
  "analytics_percentage": "Percentagem",
  "analytics_reason": "Razão",
  "analytics_recipient": "Destinatário",
  "analytics_sender": "Remetente",
  "analytics_status": "Estado",
  "analytics_subject": "Assunto",
  "analytics_temporary_error": "Ocorreu um erro temporário. Volte a tentar mais tarde.",
  "analytics_title": "Análise",
  "analytics_topforopens": "Top de aberturas",
  "analytics_total_emails": "E-mails carregados",
  "analytics_total_processed": "E-mails processados",
  "analytics_upload_date": "Carregar dados",
  "and": "e",
  "annually": "Anualmente",
  "authentication_expired": "A sua sessão expirou. Inicie sessão novamente.",
  "billing_changepassword_description": "Altere sua senha nesta área. Esta senha é usada apenas para acessar o Dashboard.",
  "billing_changepassword_title": "Alterar palavra-passe",
  "billing_contact_were_not_found": "O contacto de faturação não foi encontrado.",
  "billing_contacts_address": "Morada",
  "billing_contacts_address2": "Morada 2",
  "billing_contacts_billing": "E-mails de fatura — Faturas e lembretes de faturação",
  "billing_contacts_button_add": "Adicionar",
  "billing_contacts_button_edit": "Editar",
  "billing_contacts_city": "Cidade",
  "billing_contacts_company": "Nome da empresa",
  "billing_contacts_country": "País",
  "billing_contacts_domain_email": "Serviços",
  "billing_contacts_editcontact": "Editar contacto",
  "billing_contacts_email": "Endereço de e-mail",
  "billing_contacts_empty": "Os e-mails serão enviados para o endereço na sua conta principal. Insira mais endereços para enviar comunicações para destinatários adicionais.",
  "billing_contacts_firstname": "Primeiro nome",
  "billing_contacts_general_email": "Geral",
  "billing_contacts_invoice_email": "Faturas",
  "billing_contacts_lastname": "Último nome",
  "billing_contacts_marketing": "E-mails de serviço — avisos de renovação, confirmações de registo, etc.",
  "billing_contacts_phone": "Número de telefone",
  "billing_contacts_products": "E-mails de produtos — Detalhes da encomenda, e-mails de boas-vindas, etc.",
  "billing_contacts_products_email": "Produtos",
  "billing_contacts_slide_description": "Os e-mails serão enviados para o endereço na sua conta principal. Insira mais endereços para enviar comunicações para destinatários adicionais.",
  "billing_contacts_slide_title": "Adicionar novo contacto",
  "billing_contacts_stateregion": "Distrito / Região / Localidade",
  "billing_contacts_subscriptions": "Subscrições",
  "billing_contacts_support": "E-mails de apoio — Permita que este utilizador abra tickets na sua conta.",
  "billing_contacts_support_email": "Suporte",
  "billing_contacts_terms": "Li e concordo com a 'Política de Privacidade' e os 'Termos e Condições'.",
  "billing_contacts_title": "Adicionar contactos",
  "billing_contacts_transactional": "E-mails gerais — Anúncios gerais e lembretes de palavra-passe",
  "billing_contacts_zip": "Código postal",
  "billing_details_contact_above": "Enviar apenas para o contacto predefinido",
  "billing_emails_sentdate": "Data de envio",
  "billing_emails_subject": "Assunto",
  "billing_invoice_date": "Data de envio",
  "billing_invoice_duedate": "Data limite",
  "billing_invoice_number": "Número",
  "billing_invoice_status": "Estado",
  "billing_invoice_status_cancelled": "Cancelado",
  "billing_invoice_status_paid": "Pago",
  "billing_invoice_status_refunded": "Reembolsado",
  "billing_invoice_status_unpaid": "Não pago",
  "billing_invoice_total": "Total",
  "billing_product_payment_method_banktransfer": "Transferência bancária",
  "billing_product_paymentmethod_avangate": "Cartão de crédito (2Checkout)",
  "billing_product_paymentmethod_stripe": "Cartão de crédito (Stripe)",
  "button_add_contact": "Adicionar contacto",
  "button_add_filter": "Adicionar filtro",
  "button_add_plan": "Solicite um novo plano",
  "button_add_sender": "Adicionar remetente",
  "button_add_subaccount": "Adicionar subconta",
  "button_add_suppression": "Adicionar supressão",
  "button_add_template": "Adicionar modelo",
  "button_addbcc": "Adicionar CCO",
  "button_addfooter": "Adicionar rodapé",
  "button_advanced_search": "Pesquisa avançada",
  "button_apply": "Aplicar",
  "button_back": "Voltar",
  "button_basic_search": "Pesquisa básica",
  "button_buycredits": "Comprar créditos",
  "button_cancel": "Cancelar",
  "button_close": "Fechar",
  "button_contact_us": "Contate-Nos",
  "button_copy": "Copiar",
  "button_create": "Criar",
  "button_createalert": "Criar alerta",
  "button_delete": "Eliminar",
  "button_delete_all": "Eliminar tudo",
  "button_delete_filtered": "Eliminar filtrado",
  "button_delete_selected": "Eliminar selecionado ({n})",
  "button_edit": "Editar",
  "button_export": "Exportar",
  "button_import": "Importar ficheiro",
  "button_limits": "Definir limites",
  "button_more": "Mais",
  "button_next": "Seguinte",
  "button_open_ticket": "Abrir um novo ticket",
  "button_pay": "Pagar agora",
  "button_refresh": "Atualizar",
  "button_reload": "Atualizar",
  "button_request_cancellation": "Solicitar cancelamento",
  "button_reset": "Redefinir",
  "button_returnlist": "Voltar à lista",
  "button_save": "Guardar",
  "button_search": "Pesquisar",
  "button_select_fromdevice": "Selecione ficheiros do seu dispositivo",
  "button_submit_ticket": "Enviar ticket",
  "button_unsubscribe": "Adicionar link de cancelamento de subscrição",
  "button_update": "Atualizar",
  "button_update_template": "Atualizar modelo",
  "button_update_unsubscribe": "Atualizar link de cancelamento de subscrição",
  "button_updatealert": "Atualizar alerta",
  "button_updatebcc": "Atualizar CCO",
  "button_updatefooter": "Atualizar rodapé",
  "button_upgrade": "Atualizar",
  "button_upload": "Carregar",
  "confirm_password_is_missing": "A confirmação da palavra-passe é obrigatória.",
  "dashboard_clicked": "Clicado",
  "dashboard_delivered": "Entregue",
  "dashboard_emails_sent": "E-mails totais",
  "dashboard_emails_sent_out_of": "E-mails enviados de",
  "dashboard_gotoanalytics": "Ir para a análise",
  "dashboard_new_version": "Está disponível uma versão atualizada!",
  "dashboard_new_version_cancel": "OK",
  "dashboard_new_version_description": "Primeiro, guarde o seu trabalho e, de seguida, volte a carregar a página<br> ou prima \"Atualizar agora\" para carregar uma nova versão.",
  "dashboard_new_version_ok": "Atualizar agora",
  "dashboard_plan_emails": "e-mails",
  "dashboard_plan_label": "Plano",
  "dashboard_plan_label_interval": "{interval} Plano",
  "dashboard_plan_limit_unit_daily": "dia",
  "dashboard_plan_limit_unit_monthly": "mês",
  "dashboard_plan_limit_unit_yearly": "ano",
  "dashboard_recent_email_activities": "Atividades recentes de e-mail",
  "dashboard_try": "Está a utilizar uma \"avaliação gratuita\". Para visualizar o painel completo:",
  "datepicker_last_3_months": "Últimos 3 meses",
  "datepicker_last_30days": "Últimos 30 dias",
  "datepicker_last_month": "Mês passado",
  "datepicker_last_sevendays": "Últimos 7 dias",
  "datepicker_last_week": "Semana passada",
  "datepicker_last_year": "Ano passado",
  "datepicker_this_month": "Este mês",
  "datepicker_this_year": "Este ano",
  "datepicker_today": "Hoje",
  "datepicker_yesterday": "Ontem",
  "delete_all_bounce": "Excluir todas as devoluções",
  "delete_all_manual": "Eliminar tudo manual",
  "delete_all_spam": "Eliminar todo o spam",
  "delete_all_unsubscribe": "Eliminar todos os cancelamentos de subscrição",
  "delete_fist_login_dont": "Não mostrar esta mensagem novamente.",
  "delete_fist_login_one": "<h3>Damos-lhe as boas-vindas ao painel avançado do turboSMTP.</h3><p>Visualize estatísticas em tempo real acerca das suas campanhas de e-mail<br>e melhore os seus resultados com ferramentas profissionais.</p><h4>Siga as instruções para configurar o seu painel.</h4>",
  "delete_fist_login_three_a": "Coloque o nome do servidor SMTP no seu cliente de e-mail.",
  "delete_fist_login_three_b": "<p><strong class=\"font-xxl\">pro.turbo-smtp.com</strong></p>",
  "delete_fist_login_three_c": "Não se esqueça de configurar os registos DNS do seu domínio <br>Encontre os parâmetros nas suas 'Definições'.",
  "delete_fist_login_two_a": "<h3>Rastreamento de abertura</h3><p>permite que o turboSMTP rastreie as taxas de abertura das suas mensagens.</p>",
  "delete_fist_login_two_b": "<h3>Rastreamento de cliques</h3><p>permite que o turboSMTP rastreie as taxas de cliques das suas mensagens.</p>",
  "editor_quill_button_title": "Mostrar fonte de HTML",
  "editor_quill_cancel_text": "Cancelar",
  "editor_quill_msg": "Edite o conteúdo em formato HTML",
  "editor_quill_ok_text": "OK",
  "emails_month": "e-mails / mês",
  "emailvalidator_add_file": "Adicionar ficheiro",
  "emailvalidator_add_form_errors": "Erros no formulário",
  "emailvalidator_add_form_nofile_selected": "Nenhum ficheiro selecionado",
  "emailvalidator_add_value": "Pode adicionar entre",
  "emailvalidator_attention": "Atenção!",
  "emailvalidator_available": "créditos grátis",
  "emailvalidator_balance_description": "O seu saldo de crédito é",
  "emailvalidator_balance_title": "O seu saldo de validação",
  "emailvalidator_buy_extra_credit": "Compre crédito extra",
  "emailvalidator_complete": "Concluído",
  "emailvalidator_confirm_delete_label": "Confirmar ação",
  "emailvalidator_confirm_delete_text": "Deseja mesmo eliminar esta lista?",
  "emailvalidator_contact_support": "<a href=\"https://serversmtp.com/en/submitticket.php\" target=\"_blank\">Contacte o apoio <i class=\"ml-2 pi pi-external-link\"></i></a>",
  "emailvalidator_cost_per_email": "O custo por e-mail é",
  "emailvalidator_date": "Data de criação:",
  "emailvalidator_day": "Dia",
  "emailvalidator_details_empty": "sem elementos no interior",
  "emailvalidator_domain": "Domínio",
  "emailvalidator_domain_age": "Idade do domínio",
  "emailvalidator_email": "E-mail",
  "emailvalidator_email_addesses": "endereços de e-mail",
  "emailvalidator_empty": "Um ficheiro carregado deve conter apenas um endereço de e-mail em cada linha. Os formatos de ficheiro permitidos são csv e txt. Ou selecione um ficheiro para carregar.",
  "emailvalidator_entry_details": "Detalhes de validação",
  "emailvalidator_error": "Erro",
  "emailvalidator_error_contact_support": "Erro: contacte o apoio!",
  "emailvalidator_expiring": "expira em",
  "emailvalidator_export": "Exportar",
  "emailvalidator_free_email": "E-mail gratuito",
  "emailvalidator_how_many": "Quantos e-mails deseja validar?",
  "emailvalidator_list_contains": "A lista carregada contém",
  "emailvalidator_list_not_removed": "Erro ao remover a lista",
  "emailvalidator_list_removed": "A lista foi removida com sucesso.",
  "emailvalidator_mx_record": "Registo MX",
  "emailvalidator_please_enter_amout": "Insira o valor que deseja adicionar à sua carteira virtual.",
  "emailvalidator_price_calculator": "Calculadora de preços",
  "emailvalidator_price_email": "Preço por e-mail",
  "emailvalidator_process_now": "Processar agora",
  "emailvalidator_refresh": "atualizar",
  "emailvalidator_slide_description": "O ficheiro deve ser uma coluna que contenha todos os endereços de e-mail que pretende importar.",
  "emailvalidator_slide_details_description": "Os formatos de ficheiro permitidos são csv ou txt.",
  "emailvalidator_slide_details_title": "Arraste e solte o seu ficheiro aqui.",
  "emailvalidator_slide_manually_description": "Copie e cole múltiplos endereços de e-mail na área abaixo, separados por uma linha final.",
  "emailvalidator_slide_manually_title": "Adicionar manualmente",
  "emailvalidator_smpt_provider": "Provedor SMTP",
  "emailvalidator_status": "Estado",
  "emailvalidator_status_abuse": "Abuso",
  "emailvalidator_status_catch_all": "Catch-all",
  "emailvalidator_status_do_not_mail": "Não enviar",
  "emailvalidator_status_invalid": "Inválido",
  "emailvalidator_status_spamtrap": "Spam",
  "emailvalidator_status_unknown": "Desconhecido",
  "emailvalidator_status_valid": "Válido",
  "emailvalidator_title": "Validador de e-mail",
  "emailvalidator_total_cost": "O custo total é",
  "emailvalidator_upload_warning": "O seu saldo de crédito atual é {current_balance} Precisa de comprar {needed_balance} de crédito extra para validar esta lista...",
  "emailvalidator_validate_list": "Validar lista",
  "emailvalidator_validate_now": "Validar agora",
  "emailvalidator_validated_lists": "Listas validadas",
  "emailvalidator_validation_date": "Data de validação",
  "emailvalidator_value": "Valor",
  "emailvalidator_you_have": "Tem",
  "empty_authorization_token": "O token de autorização está em falta",
  "empty_request_body": "O pedido está incompleto",
  "error": "erro",
  "file_too_large": "file_too_large",
  "filter": "Filtro",
  "filter_by": "Filtrar por",
  "filter_fuzzy": "Pesquisa inteligente",
  "filter_fuzzy_description": "Ative esta funcionalidade para devolver itens semelhantes ao termo de pesquisa.",
  "filter_placeholder_analytics": "Pesquisar...",
  "filter_placeholder_suppressions": "Pesquisar...",
  "filter_suppressions_placeholder": "Pesquise por destinatário, remetente, assunto do e-mail ou motivo da supressão.",
  "filters_show": "Mostrar filtros",
  "filters_hide": "Ocultar filtros",
  "first_login_step": "Passo {n}",
  "forgot_password_changed": "A sua palavra-passe foi alterada com sucesso.",
  "forgot_password_click": "Clique aqui",
  "forgot_password_confirm": "Confirme a sua palavra-passe",
  "forgot_password_done": "Concluído!",
  "forgot_password_donot_match": "As palavras não correspondem.",
  "forgot_password_email_not_found": "Endereço de e-mail não encontrado",
  "forgot_password_enter_email": "Insira o seu endereço de e-mail",
  "forgot_password_error": "Ocorreu um erro ao alterar a sua palavra-passe.",
  "forgot_password_expired": "O e-mail para redefinir a sua palavra-passe expirou.",
  "forgot_password_pick": "Escolha uma palavra-passe",
  "forgot_password_please_reset": "Defina a sua palavra-passe",
  "forgot_password_recovery_email_sent": "O e-mail de recuperação foi enviado",
  "forgot_password_resend": "para enviar o e-mail novamente.",
  "forgot_password_reset": "Redefinir a sua palavra-passe",
  "forgot_password_send_password_reset_link": "Enviar um link de redefinição da palavra-passe",
  "forgot_password_sent_email_to_update_password": "Acabámos de lhe enviar um e-mail com um link para atualizar a sua palavra-passe.",
  "forgot_password_set": "Defina a sua nova palavra-passe",
  "forgot_password_should_have": "A palavra-passe deve ter",
  "forgot_password_suggestions": "<li>Pelo menos uma letra minúscula</li> <li>Pelo menos uma letra maiúscula</li><li>Pelo menos um número</li><li>Mínimo de 10 caracteres</li>",
  "forgot_password_switch": "Mudar para início de sessão",
  "forgot_password_switch_to_login": "Mudar para início de sessão",
  "forgot_password_token_is_missing": "O token de palavra-passe esquecida está em falta",
  "forgot_password_unable_to_send": "Não foi possível enviar o e-mail.",
  "forgot_password_username": "Nome de utilizador e-mail",
  "forgot_password_we_will_send_you": "Enviar-lhe-emos um link de recuperação de palavra-passe.",
  "free_account": "Conta gratuita",
  "friday": "Sexta-feira",
  "fuzzy_tooltip": "Ative esta funcionalidade para devolver itens semelhantes ao termo de pesquisa",
  "goto_emailmarketing": "Ir a Email marketing",
  "goto_emailvalidator": "Ir a Validador de e-mail",
  "header_menu_support": "https://serversmtp.com/multilanguage-customer-support/",
  "internal_server_error_try_again": "Ocorreu um erro interno do servidor. Volte a tentar mais tarde.",
  "invalid_authorization_token": "O token de autorização é inválido",
  "invalid_limit_parameter_value_must_be_greater_than_or_equals_1": "O valor limite deve ser pelo menos 1",
  "invalid_page_parameter_value_must_be_greater_than_or_equals_1": "O valor da página deve ser pelo menos 1",
  "invalid_value_for_orderby_parameter": "O parâmetro 'ordenar por' não é válido.",
  "invalid_value_for_the_parameter_type": "Valor inválido para o tipo de parâmetro",
  "invoice_not_found": "Fatura não encontrada",
  "jwt_error_full_details": "Detalhes completos",
  "jwt_error_status": "Status HTTP",
  "jwt_error_url": "URL",
  "jwt_url_not_exists": "A URL que se segue não existe",
  "l_allrights": "Todos os direitos reservados",
  "l_antispam_policy": "Política anti-spam",
  "l_copyright": "© turboSMTP 2010 - ",
  "l_dont_have_account": "Ainda não tem conta?",
  "l_email_address": "Endereço de e-mail",
  "l_forgot_password": "Esqueceu-se da palavra-passe?",
  "l_login": "Iniciar sessão",
  "l_password": "Palavra-passe",
  "l_privacy_policy": "Política de privacidade",
  "l_remember_me": "Manter a minha sessão iniciada.",
  "l_sign_up_here": "Registe-se aqui",
  "l_tagline": "TurboSMTP - provedor de serviços SMTP profissional",
  "l_username_email": "nome de utilizador e-mail",
  "l_welcome_back": "Bem-vindo de volta",
  "language_changed_label": "Alterou o idioma",
  "language_changed_message": "Para aplicar as alterações de idioma, recarregue a página",
  "language_changed_reload": "Recarregar",
  "m_accountinfo": "Informações da conta",
  "m_analytics": "Análise",
  "m_billing": "Faturas pró-forma",
  "m_daily": "Diário",
  "m_dashboard": "Painel",
  "m_emailsentout": "e-mails enviados",
  "m_emailvalidator": "Validador de e-mail",
  "m_messages": "Mensagens do sistema",
  "m_monthly": "Mensal",
  "m_myaccount": "A minha conta",
  "m_mydetails": "A minha conta",
  "m_noplans": "Sem planos",
  "m_of": "de",
  "m_products": "Os meus produtos",
  "m_savechanges": "Guardar alterações",
  "m_settings": "Definições",
  "m_subaccounts": "Subcontas",
  "m_suppressions": "Supressões",
  "m_tickets": "Os meus tickets",
  "m_validuntil": "Válido até",
  "m_yearly": "Anual",
  "missing_or_invalid_value_provided_for_whiteLabeled_variable": "O valor fornecido para a variável WhiteLabeled está ausente ou é inválido",
  "missing_required_parameter": "Falta um parâmetro obrigatório",
  "missing_required_parameter_email": "O e-mail está em falta",
  "missing_required_parameter_from": "Os dados 'De' estão em falta",
  "missing_required_parameter_to": "Os dados 'para' estão em falta",
  "missing_required_parameter_tz": "Os dados 'tz' estão em falta",
  "modal_confirmation": "Confirmação",
  "monday": "Segunda-feira",
  "monthly": "Mensalmente",
  "my_account_title": "A minha conta",
  "myaccount_2fa_title": "Autenticação de dois fatores",
  "myaccount_2fa_description": "Aumente a segurança da sua conta ativando a autenticação de dois fatores (2FA). Isso adiciona uma camada extra de proteção à sua conta.",
  "myaccount_2fa_card_description": "Ative a autenticação de dois fatores para proteger sua conta.",
  "myaccount_2fa_select_method": "Selecionar método de autenticação",
  "myaccount_2fa_method": "Método de autenticação",
  "myaccount_2fa_method_placeholder": "Escolha um método de autenticação",
  "myaccount_2fa_otp_description": "Use um aplicativo autenticador (como Google Authenticator ou Authy) para gerar códigos baseados em tempo.",
  "myaccount_2fa_email_description": "Receba códigos de verificação por e-mail.",
  "myaccount_2fa_sms_description": "Receba códigos de verificação por SMS.",
  "myaccount_2fa_none_description": "Desative a autenticação de dois fatores para sua conta.",
  "myaccount_2fa_scan_qr": "Escanear código QR",
  "myaccount_2fa_scan_qr_description": "Escaneie este código QR com seu aplicativo autenticador para configurar a autenticação de dois fatores.",
  "myaccount_2fa_manual_entry": "Ou insira este código manualmente:",
  "myaccount_2fa_copy_secret": "Copiar para a área de transferência",
  "myaccount_2fa_secret_copied": "Chave secreta copiada para a área de transferência",
  "myaccount_2fa_verify_code": "Verificar código",
  "myaccount_2fa_enter_code": "Inserir código de verificação",
  "myaccount_2fa_code_placeholder": "000000",
  "myaccount_2fa_verify_code_description": "Insira o código de 6 dígitos do seu aplicativo autenticador para concluir a configuração.",
  "myaccount_2fa_method_updated": "Método de autenticação de dois fatores atualizado com sucesso",
  "myaccount_2fa_otp_enabled": "Autenticação de dois fatores ativada com sucesso",
  "myaccount_2fa_current_status": "Status atual",
  "myaccount_2fa_status": "Status da autenticação de dois fatores",
  "myaccount_2fa_status_disabled": "Desativado",
  "myaccount_2fa_error_no_keycloak_id": "Não é possível configurar o 2FA: ID de usuário não encontrado",
  "myaccount_2fa_error_invalid_code": "Código de verificação inválido. Por favor, tente novamente.",
  "myaccount_2fa_error_generic": "Ocorreu um erro ao configurar a autenticação de dois fatores",
  "myaccount_2fa_enabled": "Ativado",
  "myaccount_2fa_disabled_label": "Desativado",
  "myaccount_2fa_disabled": "Autenticação de dois fatores desativada com sucesso",
  "myaccount_account_details": "A minha conta",
  "myaccount_billing": "Faturas pró-forma",
  "myaccount_billing_cancellation_contact_support": "Contatar o suporte",
  "myaccount_billing_cancellation_endofcycle_note": "A sua assinatura permanecerá ativa até o final do seu período de faturação atual, após o qual não será renovada.",
  "myaccount_billing_cancellation_proceed": "Continuar com o cancelamento",
  "myaccount_billing_cancellation_reason": "Razão para cancelamento",
  "myaccount_billing_cancellation_select_reason": "Selecione um motivo",
  "myaccount_billing_cancellation_support_text": "Antes de continuar, a nossa equipa de suporte pode ajudá-lo a resolver o seu problema sem cancelar. Deseja contatar-nos primeiro?",
  "myaccount_billing_contacts": "Gerir contactos",
  "myaccount_billing_contacts_description": "Os e-mails serão enviados para o endereço na sua conta principal. Insira mais endereços para enviar comunicações para destinatários adicionais.",
  "myaccount_billing_description": "Nesta secção, pode encontrar as faturas pró-forma emitidas antes das faturas fiscais.<br>nFaturas fiscais ser-lhe-ão enviadas por e-mail.",
  "myaccount_billing_details": "Detalhes de conta e faturação",
  "myaccount_billing_details_address": "Morada",
  "myaccount_billing_details_address2": "Morada 2",
  "myaccount_billing_details_billing_company_name": "Empresa de faturação",
  "myaccount_billing_details_billing_contact": "Enviar faturas pró-forma para uma morada que não seja a morada da conta",
  "myaccount_billing_details_billing_vat": "IVA / NIF",
  "myaccount_billing_details_billing_website": "Site",
  "myaccount_billing_details_city": "Cidade",
  "myaccount_billing_details_country": "País",
  "myaccount_billing_details_description": "Altere os detalhes da sua conta e a morada de faturação.",
  "myaccount_billing_details_details": "Detalhes de faturação",
  "myaccount_billing_details_email": "Endereço de e-mail",
  "myaccount_billing_details_fistname": "Primeiro nome",
  "myaccount_billing_details_lastname": "Último nome",
  "myaccount_billing_details_marketing": "Quero receber ofertas e dicas específicas do turboSMTP",
  "myaccount_billing_details_phone_number": "Número de telefone",
  "myaccount_billing_details_policy": "Li e concordo com a Política de Privacidade e os Termos e Condições",
  "myaccount_billing_details_state": "Distrito / Região",
  "myaccount_billing_details_zip": "Código postal",
  "myaccount_billing_slides_description": "Aqui pode encontrar as 'Faturas pró-forma' relacionadas com a sua conta.",
  "myaccount_billing_slides_nodata": "Não foi encontrada nenhuma fatura pró-forma",
  "myaccount_billingcontacts_added": "Contacto de faturação adicionado com sucesso",
  "myaccount_billingcontacts_deleted": "Contacto de faturação eliminado com sucesso",
  "myaccount_billingcontacts_edited": "Contacto de faturação editado com sucesso",
  "myaccount_billingdetails_updated": "Os detalhes de faturação foram atualizados",
  "myaccount_change_password": "Alterar palavra-passe",
  "myaccount_confirm_delete_selectedcontact_label": "Confirmar ação",
  "myaccount_confirm_delete_selectedcontact_text": "Deseja mesmo eliminar este contacto?",
  "myaccount_confirm_password": "Confirmar palavra-passe",
  "myaccount_current_password": "Verifique a palavra-passe atual",
  "myaccount_delimiter_change": "Alterar delimitador de exportação CSV",
  "myaccount_delimiter_select": "Selecionar delimitador",
  "myaccount_language": "Exibir idioma",
  "myaccount_language_change": "Alterar idioma",
  "myaccount_language_description": "O TurboSMTP agora está disponível em inglês e em italiano. (As versões em francês, alemão, hebraico, português, russo, árabe e espanhol estarão disponíveis em breve).",
  "myaccount_language_select": "Selecionar idioma",
  "myaccount_localization": "Localização",
  "myaccount_localization_description": "Alterar o idioma ou delimitador de exportação do CSV.",
  "myaccount_messages": "Mensagens do sistema",
  "myaccount_messages_nomessages": "Nenhuma mensagem recebida",
  "myaccount_messages_nomessages_description": "Nesta secção encontrará as mensagens que o nosso sistema enviou para a sua conta.",
  "myaccount_new_password": "Nova palavra-passe",
  "myaccount_password_changed": "A palavra-passe foi alterada com sucesso",
  "myaccount_password_choose": "Escolha a sua nova palavra-passe",
  "myaccount_password_notmatch": "Estas palavras-passe não corresponderam. Tente novamente.",
  "myaccount_password_suggestions": "Uma palavra-passe deve conter pelo menos 10 caracteres, incluindo letras maiúsculas e minúsculas e pelo menos um número.",
  "myaccount_product_delete_label": "Confirmar ação",
  "myaccount_product_delete_text": "Tem a certeza de que deseja cancelar este produto?",
  "myaccount_product_deleted": "A solicitação de cancelamento foi enviada com sucesso.",
  "myaccount_products": "Os meus produtos",
  "myaccount_products_billingcycle": "Ciclo de faturação",
  "myaccount_products_cycle_annually": "Anualmente",
  "myaccount_products_cycle_biennally": "Bienalmente",
  "myaccount_products_cycle_free_account": "Conta gratuita",
  "myaccount_products_cycle_month": "Mensalmente",
  "myaccount_products_cycle_monthly": "Mensalmente",
  "myaccount_products_cycle_one_time": "Uma vez",
  "myaccount_products_cycle_onetime": "Uma vez",
  "myaccount_products_cycle_quarterly": "Trimestralmente",
  "myaccount_products_cycle_semi-annually": "Semianualmente",
  "myaccount_products_cycle_triennially": "Trienalmente",
  "myaccount_products_cycle_year": "Anual",
  "myaccount_products_cycle_yearly": "Anual",
  "myaccount_products_fistpayment": "Primeiro valor de pagamento",
  "myaccount_products_nextduedate": "Próxima data de vencimento",
  "myaccount_products_noproduct": "Não há produtos",
  "myaccount_products_noproduct_description": "Nesta secção encontrará os produtos e serviços associados à conta.",
  "myaccount_products_payment": "Método de pagamento",
  "myaccount_products_price": "Preço",
  "myaccount_products_productservice": "Produto / serviço",
  "myaccount_products_recurringamount": "Valor recorrente",
  "myaccount_products_registration": "Data de registo",
  "myaccount_products_slide_productservice_description": "Pode gerir o seu produto diretamente a partir desta área.",
  "myaccount_products_status": "Estado",
  "plans_addon_options_title": "Planos complementares",
  "plans_available_recurring_options_title": "Planos Disponíveis",
  "plans_billing_cycle": "Ciclo de faturação",
  "plans_current_plans_title": "Os seus planos atuais",
  "plans_cycle_month": "Mensal",
  "plans_cycle_monthly": "Mensal",
  "plans_cycle_onetime": "Única vez",
  "plans_cycle_year": "Anual",
  "plans_cycle_yearly": "Anual",
  "plans_downgrade_options_title": "Opções de downgrade",
  "plans_feature_dedicated_ip": "IP dedicado",
  "plans_feature_email_credits": "Créditos de email",
  "plans_feature_smtp_limit": "Limite SMTP",
  "plans_features": "Características",
  "plans_invoice_created": "A fatura foi criada com sucesso.",
  "plans_invoice_error": "Não foi possível criar a fatura. Tente novamente.",
  "plans_load_error": "Não foi possível carregar as opções do plano. Tente novamente.",
  "plans_onetime_options_title": "Planos de única vez",
  "plans_plan_name": "Nome do plano",
  "plans_plan_type": "Tipo de plano",
  "plans_select_plan": "Selecionar plano",
  "plans_type_addon": "Complemento",
  "plans_type_onetime": "Única vez",
  "plans_type_recurring": "Recorrente",
  "plans_upgrade_options_title": "Opções de upgrade",
  "myaccount_sentdate": "Data de envio",
  "new_dashboard_error": "Pedimos desculpa, ocorreu um erro:",
  "new_dashboard_if_you_think": "Se considera que está a ver esta mensagem por engano, por favor <a href=\"https://serversmtp.com/pt-pt/contactos/\" target=\"_blank\" >contacte-nos</a>.",
  "new_dashboard_not_allowed": "Contacte a nossa <a href='https://serversmtp.com/pt-pt/contactos/' target='_blank'>equipa de apoio</a> para começar a utilizar a versão Painel Beta.",
  "new_dashboard_token_valid": "O token é válido",
  "new_dashboard_token_wrong": "O token está incorreto",
  "new_dashboard_validating": "A validar o token...",
  "no": "Não",
  "no_parameters_was_provided_for_update": "Não foi fornecido nenhum parâmetro para atualização",
  "no_suppression_data_were_provided": "Não foram fornecidos dados de supressão",
  "one_time": "Uma vez",
  "optional": "Opcional",
  "or": "ou",
  "password_is_invalid": "Nenhuma conta corresponde a esta palavra-passe",
  "password_is_missing": "A palavra-passe está em falta",
  "password_length_should_not_be_less_than_10_characters": "A palavra-passe deve conter pelo menos 10 caracteres",
  "password_should_contain_at_least_one_uppercase_character": "A senha deve conter pelo menos 1 caractere maiúsculo",
  "password_should_contain_at_least_one_lowercase_character": "A senha deve conter pelo menos 1 caractere minúsculo",
  "password_should_contain_at_least_one_digit": "A senha deve conter pelo menos 1 dígito",
  "password_should_equals_to_confirm_password": "A palavra-passe e a confirmação devem corresponder",
  "plan": "plano",
  "plan_daily": "Plano diário",
  "plan_monthly": "Plano mensal",
  "plan_short_daily": " dia",
  "plan_short_monthly": "mês",
  "plan_short_yearly": "ano",
  "plan_yearly": "Plano anual",
  "primeng": {
    "accept": "Sim",
    "addRule": "Adicionar regra",
    "after": "Depois",
    "apply": "Aplicar",
    "before": "Antes",
    "cancel": "Cancelar",
    "choose": "Escolha",
    "clear": "Limpar",
    "contains": "Contém",
    "dateAfter": "A data é depois de",
    "dateBefore": "A data é antes de",
    "dateFormat": "dd/mm/yy",
    "dateIs": "A data é",
    "dateIsNot": "A data não é",
    "dayNames": [
      "domingo",
      "segunda",
      "terça",
      "quarta",
      "quinta",
      "sexta",
      "sábado"
    ],
    "dayNamesMin": [
      "Do",
      "Se",
      "Te",
      "Qa",
      "Qi",
      "Sx",
      "Sa"
    ],
    "dayNamesShort": [
      "dom",
      "seg",
      "ter",
      "qua",
      "qui",
      "sex",
      "sáb"
    ],
    "emptyFilterMessage": "Nenhum resultado encontrado",
    "emptyMessage": "Nenhum resultado encontrado",
    "endsWith": "Termina com",
    "equals": "Igual a",
    "firstDayOfWeek": 1,
    "gt": "Maior do que",
    "gte": "Maior do que ou igual a",
    "is": "É",
    "isNot": "Não é",
    "lt": "Menos do que",
    "lte": "Menos do que ou igual a",
    "max_limit_reached": "Você atingiu o número máximo de subcontas ativáveis no seu plano atual.",
    "matchAll": "Combinar todos",
    "matchAny": "Combinar qualquer",
    "medium": "Medium",
    "monthNames": [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ],
    "monthNamesShort": [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez"
    ],
    "noFilter": "Nenhum filtro",
    "notContains": "Não contém",
    "notEquals": "Não é igual a",
    "passwordPrompt": "insira uma senha",
    "reject": "Não",
    "removeRule": "Remover regra",
    "startsWith": "Começa com",
    "strong": "Forte",
    "today": "Hoje",
    "upload": "Carregar",
    "weak": "Fraca",
    "weekHeader": "Finde"
  },
  "return_toaddons": "Voltar para addons",
  "saturday": "Sábado",
  "server_error_please_try_again": "Erro do servidor. Volte a tentar mais tarde.",
  "server_error_while_performing_update": "Ocorreu um erro no servidor durante a atualização",
  "server_problem_gateway_timeout": "Tempo limite do gateway do servidor, tente novamente.",
  "server_problem_please_retry": "Ocorreu um problema no servidor, tente novamente.",
  "server_problem_unknown_error": "Ocorreu um erro de servidor desconhecido, tente novamente.",
  "settings_activities_description": "Receba relatórios da atividade da conta na sua caixa de correio. Os relatórios podem ser diários, semanais e / ou mensais, e abrangem todas as atividades da sua conta.",
  "settings_activities_slide_dailyreport": "Relatório diário",
  "settings_activities_slide_day": "Dia",
  "settings_activities_slide_dayoftheweek": "Dia da semana",
  "settings_activities_slide_description": "Pode receber relatórios diários, semanais e mensais de todas as atividades da sua conta. O seu relatório será enviado para o endereço de e-mail que registou.",
  "settings_activities_slide_monthlyreport": "Relatório mensal",
  "settings_activities_slide_time": "Hora",
  "settings_activities_slide_title": "Relatórios de atividade",
  "settings_activities_slide_weeklyreport": "Relatório semanal",
  "settings_activities_title": "Relatórios de atividade",
  "settings_alert_usage_limit": "Limite de utilização",
  "settings_alerts_description": "Receba um alerta por e-mail quando tiver utilizado uma percentagem específica dos seus créditos de e-mail.",
  "settings_alerts_slide_add": "Adicionar um alerta",
  "settings_alerts_slide_description": "Para evitar ficar sem relays a meio de um envio, receba um alerta por e-mail quando atingir uma determinada percentagem dos seus créditos. Sugerimos que ative o alerta nos 80% do seu crédito disponível.",
  "settings_alerts_slide_empty_description": "Defina um alerta que será entregue no seu endereço de e-mail quando atingir uma determinada percentagem dos seus créditos.",
  "settings_alerts_slide_empty_title": "Adicionar um alerta",
  "settings_alerts_slide_frequency": "Frequência",
  "settings_alerts_slide_percentage": "Percentagem",
  "settings_alerts_slide_placeholder": "p. ex., nome@endereco.com",
  "settings_alerts_slide_sendto": "Enviar para",
  "settings_alerts_slide_title": "Alertas",
  "settings_alerts_slide_type": "Tipo de alerta",
  "settings_alerts_title": "Alertas",
  "settings_api_description": "Envie os seus e-mails diretamente do seu site ou aplicação com o API do turboSMTP.",
  "settings_api_title": "Documentação da API",
  "settings_bccs_description": "Cada endereço de e-mail na lista CCO receberá uma cópia de cada e-mail sem que o destinatário veja os detalhes dos outros destinatários.",
  "settings_bccs_enable": "Habilitar para autorizar uma conta de e-mail para receber uma cópia de quaisquer e-mails enviados.",
  "settings_bccs_slide_add": "Adicionar CCOs",
  "settings_bccs_slide_description": "Defina e autorize uma ou mais contas de e-mail a receber uma cópia de quaisquer e-mails.",
  "settings_bccs_slide_email": "E-mail",
  "settings_bccs_slide_empty": "Defina e autorize uma conta de e-mail para receber uma cópia de quaisquer e-mails.",
  "settings_bccs_slide_empty_title": "Adicionar um endereço CCO",
  "settings_bccs_slide_name": "Nome",
  "settings_bccs_slide_not_verified": "Não verificado",
  "settings_bccs_slide_status": "Estado",
  "settings_bccs_slide_title": "CCOs (Com cópia oculta)",
  "settings_bccs_slide_verified": "Verificado",
  "settings_bccs_title": "CCOs (Com cópia oculta)",
  "settings_bounces_description": "A ativação das notificações de devolução nos enviará notificações sobre seus e-mails devolvidos. Para receber você mesmo todas as notificações de devolução, desative esta opção.",
  "settings_bounces_title": "Gestão de devoluções",
  "settings_click_tracking": "Rastreamento de cliques",
  "settings_click_tracking_description": "O rastreamento de cliques regista todos os cliques feitos em cada link presente nos seus e-mails.",
  "settings_dns_bar_description": "Os registos SPF e DKIM devem ser adicionados a todos os domínios do endereço de e-mail do remetente.",
  "settings_dns_bar_dkim_description": "É possível adicionar um registro DKIM como registo TXT inserindo o seguinte:",
  "settings_dns_bar_dkim_title": "Registos DKIM",
  "settings_dns_bar_domainaut": "Autenticação de domínio",
  "settings_dns_bar_domainaut_description": "Permita que o TurboSMTP envie e-mails em seu nome.",
  "settings_dns_bar_domainaut_is": "O modo 'Autenticação de Domínio' é:",
  "settings_dns_bar_spf_description": "Adicione o seguinte registo TXT ao domínio do endereço do envelope (exemplo.com), num dos dois casos seguintes:",
  "settings_dns_bar_spf_description_a": "<strong>Se já existir um registro SPF na configuração DNS do seu domínio</strong>, você precisará modificá-lo. Basta adicionar",
  "settings_dns_bar_spf_description_b": "diretamente após o segmento",
  "settings_dns_bar_spf_description_c": "Lembre-se de deixar um espaço antes e depois desta adição para manter a sintaxe adequada.",
  "settings_dns_bar_spf_description_d": "<strong>Se não houver um registro SPF existente</strong>, prossiga configurando um, inserindo as informações necessárias em um novo registro TXT dentro da configuração DNS do seu domínio (não é necessário especificar um Domínio SPF a menos que seja exigido):",
  "settings_dns_bar_spf_title": "Registo SPF",
  "settings_dns_bar_title": "Definições do DNS",
  "settings_dns_description": "Adicione os nossos registos DNS ao seu domínio para assinar os seus e-mails com DKIM e assegurar uma capacidade de entrega otimada.",
  "settings_dns_title": "Registos DNS",
  "settings_email_body_tip": "Especifique <% body %> na sua entrada.",
  "settings_email_elements": "Elementos do e-mail",
  "settings_email_footers_added": "Rodapé adicionado com sucesso",
  "settings_email_footers_confirm_delete_label": "Confirmar ação",
  "settings_email_footers_confirm_delete_text": "Deseja mesmo eliminar este rodapé?",
  "settings_email_footers_default": "Definições de rodapé atualizadas com sucesso",
  "settings_email_footers_removed": "Rodapé removido com sucesso",
  "settings_email_footers_updated": "Rodapé atualizado com sucesso",
  "settings_email_name_tip": "Especifique um nome",
  "settings_email_templates_added": "Modelo adicionado com sucesso",
  "settings_email_templates_confirm_delete_label": "Confirmar ação",
  "settings_email_templates_confirm_delete_text": "Deseja mesmo eliminar este modelo?",
  "settings_email_templates_default": "Definições atualizadas com sucesso",
  "settings_email_templates_removed": "Modelo removido com sucesso",
  "settings_email_templates_updated": "Modelo atualizado com sucesso",
  "settings_email_unsub_added": "Link de cancelamento de subscrição adicionado com sucesso",
  "settings_email_unsub_confirm_delete_label": "Confirmar ação",
  "settings_email_unsub_confirm_delete_text": "Deseja mesmo eliminar este link de cancelamento de subscrição?",
  "settings_email_unsub_removed": "Link de cancelamento de subscrição removido com sucesso",
  "settings_email_unsub_updated": "Link de cancelamento de subscrição atualizado com sucesso",
  "settings_footers_description": "Adicione um rodapé aos seus e-mails.",
  "settings_footers_slide_add": "Adicionar rodapé",
  "settings_footers_slide_convert": "HTML para Texto",
  "settings_footers_slide_default": "Predefinido",
  "settings_footers_slide_description": "Clique em \"Adicionar Rodapé\" ou edite um rodapé existente, depois introduza o nome do rodapé e preencha os campos utilizando HTML ou texto simples.",
  "settings_footers_slide_empty_description": "Clique em \"Adicionar Rodapé\" ou edite um rodapé existente, depois introduza o nome do rodapé e preencha os campos utilizando HTML ou texto simples.",
  "settings_footers_slide_empty_title": "Sem rodapés",
  "settings_footers_slide_htmltext": "Texto HTML",
  "settings_footers_slide_name": "Nome",
  "settings_footers_slide_plaintext": "Texto simples",
  "settings_footers_slide_title": "Rodapés",
  "settings_footers_title": "Rodapés",
  "settings_ga_bar_description": "Preencha os seguintes campos, incluindo o nome e a fonte dos dados da sua campanha, para ativar a respetiva integração com o Google Analytics.",
  "settings_ga_bar_title": "Google Analytics",
  "settings_ga_content": "Conteúdo da campanha",
  "settings_ga_content_mandatory": "O conteúdo da campanha é obrigatório",
  "settings_ga_integrate": "Integre o Google Analytics para acompanhar as suas taxas de conversão e outros dados",
  "settings_ga_medium": "Meio da campanha",
  "settings_ga_medium_mandatory": "O meio de campanha é obrigatório",
  "settings_ga_name": "Nome da campanha",
  "settings_ga_name_mandatory": "O nome da campanha é obrigatório",
  "settings_ga_parameters": "Parâmetros",
  "settings_ga_parameters_description": "Preencha os seguintes campos, incluindo o nome e a fonte dos dados da sua campanha, para ativar a respetiva integração com o Google Analytics.",
  "settings_ga_source": "Fonte da campanha",
  "settings_ga_source_mandatory": "A fonte da campanha é obrigatória",
  "settings_ga_term": "Termo da campanha",
  "settings_ga_term_mandatory": "O termo da campanha é obrigatório",
  "settings_google_analytics_description": "O Google Analytics rastreia as suas taxas de conversão e outros dados.",
  "settings_google_analytics_title": "Google Analytics",
  "settings_integrations": "Integrações",
  "settings_integrations_authentication_disabled": "O modo 'Autenticação de Domínio' é: Desativado",
  "settings_integrations_authentication_enabled": "O modo 'Autenticação de Domínio' é: Ativado",
  "settings_integrations_dkim_updated": "Configurações do DKIM atualizadas com sucesso",
  "settings_notification_alert_confirm_delete_label": "Confirmar ação",
  "settings_notification_alert_confirm_delete_text": "Deseja mesmo apagar este alerta?",
  "settings_notification_bcc_confirm_delete_label": "Confirmar ação",
  "settings_notification_bcc_confirm_delete_success": "O {email} CCO foi eliminado com sucesso.",
  "settings_notification_bcc_confirm_delete_text": "Deseja mesmo eliminar este {email} CCO?",
  "settings_notification_smtp_auth": "Autenticação SMTP",
  "settings_notifications": "Notificações",
  "settings_notifications_alert_added": "O alerta foi criado com sucesso",
  "settings_notifications_alert_deleted": "O alerta foi eliminado com sucesso.",
  "settings_notifications_alert_updated": "O alerta foi atualizado com sucesso",
  "settings_notifications_bcc_emailbox": "Acabámos de enviar uma mensagem de verificação para <{email}>.",
  "settings_notifications_bcc_update_success": "O CCO {email} foi atualizado com sucesso.",
  "settings_notifications_smtp_auth_enabled": "Ativado",
  "settings_notifications_smtp_host": "pro.turbo-smtp.com",
  "settings_notifications_smtp_host_eu": "pro.eu.turbo-smtp.com",
  "settings_notifications_smtp_passvalue": "*********<br>(a senha que você usa para entrar neste painel de controle)",
  "settings_notifications_smtp_password": "Palavra-passe SMTP",
  "settings_notifications_smtp_ports": "Portas SMTP",
  "settings_notifications_smtp_server": "Servidor SMTP",
  "settings_notifications_smtp_username": "Nome de utilizador SMTP",
  "settings_open_tracking": "Rastreamento de abertura",
  "settings_open_tracking_description": "A ativação do rastreamento de abertura criará um registo das suas mensagens abertas, permitindo que acompanhe melhor os resultados da campanha.",
  "settings_setting_changed": "Definição alterada {service}",
  "settings_setting_disabled": "Definição desativada {service}",
  "settings_setting_enabled": "Definição ativada {service}",
  "settings_setting_notdisabled": "A definição {service} não pode ser ativada.",
  "settings_setting_notenabled": "A definição {service} não pode ser ativada.",
  "settings_setting_webhook_notenabled": "Os Web-hooks de notificação de eventos estão disponíveis apenas nos planos recorrentes PRO.",
  "settings_smtp_description": "Para se ligar via SMTP, configure o SMTP no seu cliente de e-mail ou em qualquer outra aplicação de envio de e-mails, adicionando os parâmetros que se seguem. Clique no botão “Mais” para ver os parâmetros.",
  "settings_smtp_slide_description": "Configure o SMTP no seu cliente de e-mail ou em qualquer outra aplicação de envio de e-mails, adicionando os parâmetros que se seguem.",
  "settings_smtp_slide_description_api": "O nome de usuário e a senha de autenticação SMTP são um par de chaves de API: use o Consumer Key como nome de usuário SMTP e o Consumer Secret como senha SMTP. Trate-os como credenciais que devem ser mantidas em segredo e rotacionadas, se necessário.",
  "settings_smtp_slide_parameter": "Parâmetro",
  "settings_smtp_slide_title": "Ligação por SMTP",
  "settings_smtp_slide_value": "Valor",
  "settings_smtp_title": "Ligação por SMTP",
  "settings_template_description": "Os modelos são a ferramenta perfeita para dar facilmente um layout eficaz ao seu e-mail.",
  "settings_template_slide_add": "Adicionar modelo",
  "settings_template_slide_default": "Predefinido",
  "settings_template_slide_description": "Clique em \"Adicionar modelo\" e preencha os campos com a informação necessária, incluindo o nome do modelo e HTML ou texto simples.",
  "settings_template_slide_empty_description": "Clique em \"Adicionar modelo\" e preencha os campos com a informação necessária, incluindo o nome do modelo e HTML ou texto simples.",
  "settings_template_slide_empty_title": "Adicionar um modelo",
  "settings_template_slide_html": "Versão HTML",
  "settings_template_slide_info": "<% body %> é obrigatório em texto HTML e em texto simples. O marcador de posição será substituído pelo conteúdo real.",
  "settings_template_slide_name": "Nome do modelo",
  "settings_template_slide_plaintext": "Versão de texto simplificado",
  "settings_template_slide_title": "Modelos",
  "settings_template_title": "Modelos",
  "settings_title": "Definições",
  "settings_tracking": "Rastreamento",
  "settings_unsubscribe_description": "Adicione um link para cancelar a subscrição no fim dos e-mails de texto e HTML. Não serão entregues e-mails a utilizadores que cancelaram a subscrição.",
  "settings_unsubscribe_select": "Selecionar um idioma",
  "settings_unsubscribe_slide_add": "Adicionar link para cancelar a subscrição",
  "settings_unsubscribe_slide_description": "Adicione um link para cancelar a subscrição no fim dos e-mails de texto e HTML. Não serão entregues e-mails a utilizadores que cancelaram a subscrição. Os cancelamentos de subscrição serão tratados automaticamente e em tempo real para melhorar a sua reputação de envio de e-mails. Digite o texto que deseja utilizar (como \"Para cancelar a subscrição, clique aqui\") e cole o texto na marcador de posição presente na sua mensagem.",
  "settings_unsubscribe_slide_empty": "Adicionar link para cancelar a subscrição",
  "settings_unsubscribe_slide_empty_description": "Adicione um link para cancelar a subscrição no fim dos e-mails de texto e HTML. Não serão entregues e-mails a utilizadores que cancelaram a subscrição. Os cancelamentos de subscrição serão tratados automaticamente e em tempo real para melhorar a sua reputação de envio de e-mails.",
  "settings_unsubscribe_slide_language": "Selecionar um idioma",
  "settings_unsubscribe_slide_placeholder": "Marcador de posição",
  "settings_unsubscribe_slide_text": "Texto de cancelamento de subscrição",
  "settings_unsubscribe_slide_title": "Link de cancelamento de subscrição",
  "settings_unsubscribe_text": "Texto",
  "settings_unsubscribe_title": "Link de cancelamento de subscrição",
  "settings_unsubscribe_value": "P. ex.: Para cancelar a subscrição, clique aqui",
  "settings_webhooks_description": "Os webhooks permitem que a sua aplicação web receba notificações de eventos de entrega de e-mails e de interação.",
  "settings_webhooks_slide_bounced": "Devolvido",
  "settings_webhooks_slide_click": "Clique",
  "settings_webhooks_slide_deferred": "Diferido",
  "settings_webhooks_slide_delivered": "Entregue",
  "settings_webhooks_slide_deliveryevents": "Eventos de entrega",
  "settings_webhooks_slide_description": "Pode utilizar os Webhooks de Notificação de Eventos para ser notificado dos eventos ocorridos no seu projeto de e-mail, sem utilizar APIs.",
  "settings_webhooks_slide_dropped": "Abandonado",
  "settings_webhooks_slide_engagementevents": "Eventos de engagement",
  "settings_webhooks_slide_inserturl": "Insira aqui a URL relativamente à qual deseja ser notificado",
  "settings_webhooks_slide_notification": "URL de notificação do webhook",
  "settings_webhooks_slide_notification_description": "Ativar notificações de webhook",
  "settings_webhooks_slide_open": "Aberto",
  "settings_webhooks_slide_placeholder": "https://",
  "settings_webhooks_slide_processed": "Processado",
  "settings_webhooks_slide_spamreport": "Denúncia de spam",
  "settings_webhooks_slide_title": "Webhooks",
  "settings_webhooks_slide_unsubscribe": "Cancelar subscrição",
  "settings_webhooks_support": "Contacte o apoio e solicite a 'Ativação de eventos de entrega'.",
  "settings_webhooks_title": "Webhooks",
  "settings_webhooks_upgrade": "Fazer upgrade para o plano PRO",
  "startsWith": "Começa com",
  "subaccount_policy_agree": "Li e concordo com os <a href=\"https://serversmtp.com/pt-pt/terms-and-conditions/\" target=\"_blank\">termos de serviço</a> e <a href=\"https://serversmtp.com/pt-pt/politica-de-privacidade-regulamento-da-ue-2016-79-rgpd/\" target=\"_blank\">política de privacidade</a>",
  "subaccount_policy_agree_notchecked": "Deve concordar com os termos de serviço e política de privacidade.",
  "subaccount_slide_inuse": "Em utilização",
  "subaccount_slide_ip": "IP",
  "subaccount_slide_ips": "IPs",
  "subaccount_slide_ips_description": "Selecione um IP para atribuir a esta subconta.",
  "subaccounts_action_activated": "{email} foi ativado com sucesso",
  "subaccounts_action_active": "Ativo",
  "subaccounts_action_deactivated": "{email} foi suspenso com sucesso",
  "subaccounts_action_delete": "Eliminar",
  "subaccounts_action_deleted": "Subconta eliminada com sucesso",
  "subaccounts_action_details": "Detalhes",
  "subaccounts_action_edit": "Editar",
  "subaccounts_action_limit": "Definir limites",
  "subaccounts_action_login": "Iniciar sessão",
  "subaccounts_action_notdeleted": "Erro ao eliminar subconta",
  "subaccounts_action_suspend": "Suspender",
  "subaccounts_active": "Ativo",
  "subaccounts_added_succesfully": "A subconta foi adicionada com sucesso",
  "subaccounts_agencysettings": "Configurações da agência",
  "subaccounts_assigned_ip": "IP atribuído",
  "subaccounts_changed_succesfully": "A subconta foi alterada com sucesso",
  "subaccounts_confirm_activation_label": "Confirmar ativação",
  "subaccounts_confirm_activation_text": "Deseja ativar {email}?",
  "subaccounts_confirm_deactivation_label": "Confirmar desativação",
  "subaccounts_confirm_deactivation_text": "Deseja suspender a subconta: {email}?",
  "subaccounts_confirm_delete_label": "Confirmar eliminação",
  "subaccounts_confirm_delete_text": "Deseja eliminar a subconta {email}?",
  "subaccounts_confirm_login_label": "Confirmar início de sessão",
  "subaccounts_confirm_login_text": "Tem a certeza de que deseja sair da conta atual e iniciar sessão em {email}?",
  "subaccounts_confirmation": "Confirmação",
  "subaccounts_create_warning": "A criação de novas subcontas só está disponível para subscrições profissionais.",
  "subaccounts_email": "E-mail da conta",
  "subaccounts_empty": "Amplie o seu negócio e ofereça aos seus clientes um serviço profissional totalmente personalizável com a sua marca, ou divida os seus e-mails entre os seus funcionários e colegas.<br>Uma interface de gestão simples permitir-lhe-á monitorizar o tráfego e as estatísticas.",
  "subaccounts_expiration_date": "Data de expiração",
  "subaccounts_inactive": "Inativo",
  "subaccounts_ip": "IP",
  "subaccounts_last_activity": "Última atividade",
  "subaccounts_limits_nolimits": "Sem limites",
  "subaccounts_limits_sending": "Limite de envio:",
  "subaccounts_limits_slide_description": "Defina um limite para a sua subconta.",
  "subaccounts_limits_slide_limits": "Limites",
  "subaccounts_limits_slide_noplan_expiration": "Sem vencimento",
  "subaccounts_limits_slide_plan_expiration": "Expiração do plano",
  "subaccounts_limits_slide_set_plan_expiration": "Definir expiração do plano",
  "subaccounts_limits_slide_this_number": "Este número refere-se a um período",
  "subaccounts_limits_slide_title": "Limite de subcontas",
  "subaccounts_no_expiration": "({master_expiration_date}) <i class=\"pi pi-info-circle\"></i>",
  "subaccounts_no_expiration_tooltip": "De acordo com a expiração do plano da conta principal",
  "subaccounts_settings_update": "As definições da subconta estão agora atualizadas.",
  "subaccounts_slide_account_confirm": "Confirmar detalhes da conta",
  "subaccounts_slide_account_description": "Clique no botão Editar para alterar as informações de utilizador da sua subconta.",
  "subaccounts_slide_account_info": "Informação da conta",
  "subaccounts_slide_address": "Morada",
  "subaccounts_slide_address2": "Morada 2",
  "subaccounts_slide_change_password": "Defina uma palavra-passe",
  "subaccounts_slide_city": "Cidade",
  "subaccounts_slide_company": "Nome da empresa",
  "subaccounts_slide_confirm_password": "Confirmar palavra-passe",
  "subaccounts_slide_confirmpassword_different": "Certifique-se de que as suas palavras-passe correspondem.",
  "subaccounts_slide_country": "País",
  "subaccounts_slide_email": "Endereço de e-mail",
  "subaccounts_slide_email_not_unique": "Este endereço de e-mail já está a ser utilizado.",
  "subaccounts_slide_email_required": "É necessário um endereço de e-mail.",
  "subaccounts_slide_first_name": "Primeiro nome",
  "subaccounts_slide_firstname_required": "O primeiro nome é obrigatório.",
  "subaccounts_slide_last_name": "Último nome",
  "subaccounts_slide_lastname_required": "O último nome é obrigatório.",
  "subaccounts_slide_password": "Palavra-passe",
  "subaccounts_slide_password_details": "Deixe o campo da palavra-passe em branco para continuar a utilizar a sua palavra-passe atual.",
  "subaccounts_slide_password_minlength": "O comprimento da palavra-passe deve ser pelo menos {req}. Atualmente é: {act}.",
  "subaccounts_slide_password_required": "A palavra-passe é obrigatória.",
  "subaccounts_slide_password_pattern": "A senha deve conter pelo menos 10 caracteres, dos quais pelo menos um maiúsculo, um minúsculo e um dígito",
  "subaccounts_slide_phone": "Telefone",
  "subaccounts_slide_profile_information": "Informações do perfil",
  "subaccounts_slide_region": "Distrito / Região / Localidade",
  "subaccounts_slide_website": "Site",
  "subaccounts_slide_zip": "Código postal",
  "subaccounts_status": "Estado",
  "subaccounts_subaccounts": "Lista de subcontas",
  "subaccounts_title": "Subcontas",
  "subaccounts_unlimited": "Ilimitado <i class='pi pi-info-circle'></i>",
  "subaccounts_unlimited_tooltip": "De acordo com o limite do plano da conta principal.",
  "subaccounts_usage": "Utilização",
  "sunday": "Domingo",
  "suppression_deleted": "As supressões serão eliminadas em breve.",
  "suppression_filters_reason": "Motivo",
  "suppression_filters_recipient": "Destinatário",
  "suppression_filters_sender": "Remetente",
  "suppression_filters_sources": "Fontes",
  "suppression_filters_subject": "Assunto do e-mail",
  "suppression_operators_exclude": "Excluir",
  "suppression_operators_include": "Incluir",
  "suppression_table_addcolumn_sender": "Remetente",
  "suppression_table_dropdown_text": "{first} — {last} de {totalRecords}",
  "suppression_types_bounce": "Devolvido",
  "suppression_types_manual": "Manual",
  "suppression_types_spam": "Spam",
  "suppression_types_unsubscribe": "Cancelou a subscrição",
  "suppression_types_validation_failed": "A validação falhou",
  "suppressions_add_form_errors": "Erros no formulário",
  "suppressions_add_form_nofile_selected": "Nenhum ficheiro selecionado",
  "suppressions_add_suppression": "Importar supressões",
  "suppressions_choose_columns": "Escolher colunas",
  "suppressions_confirm_delete_all_label": "Confirmar ação",
  "suppressions_confirm_delete_all_text": "Deseja mesmo eliminar todas as supressões entre <strong>{from}</strong> e <strong>{to}</strong>?",
  "suppressions_confirm_delete_all_type_text": "Deseja mesmo eliminar<br> todas as supressões <strong>{type}</strong> entre <strong>{from}</strong> e <strong>{to}</strong>?",
  "suppressions_confirm_delete_filtered_label": "Confirmar ação",
  "suppressions_confirm_delete_filtered_text": "Deseja mesmo eliminar todas as <strong>supressões filtradas</strong>? <br><small>*As entradas de spam não serão eliminadas.</small>",
  "suppressions_confirm_delete_selected_label": "Confirmar ação",
  "suppressions_confirm_delete_selected_text": "Deseja mesmo eliminar as supressões selecionadas?",
  "suppressions_date": "Data",
  "suppressions_delete_all": "Eliminar tudo",
  "suppressions_delete_selected": "Eliminar a seleção",
  "suppressions_deleted": "As supressões serão eliminadas em breve.",
  "suppressions_description_empty": "Não foram encontradas entradas para o período selecionado.",
  "suppressions_details_date": "Data",
  "suppressions_details_entry": "Entrada",
  "suppressions_details_reason": "Motivo",
  "suppressions_details_sender": "Remetente",
  "suppressions_details_subject": "Assunto",
  "suppressions_details_title": "Detalhes",
  "suppressions_details_type": "Tipo",
  "suppressions_imported": "As suas supressões serão importadas em breve.",
  "suppressions_imported_partial": "{imported} / {total} supressões serão importadas em breve.",
  "suppressions_include": "Incluir",
  "suppressions_modal_confirm": "Confirmação",
  "suppressions_not_imported": "As supressões não serão importadas devido a e-mails inválidos.",
  "suppressions_reason": "Motivo",
  "suppressions_recipient": "Destinatário",
  "suppressions_subject": "Assunto",
  "suppressions_title": "Supressões",
  "suppressions_title_empty": "Não foram encontradas supressões",
  "suppressions_type": "Tipo",
  "t_api": "Documentação da API",
  "t_knowledgebase": "Base de conhecimentos",
  "t_logout": "Terminar sessão",
  "table_dropdown_goto": "Ir para a página",
  "table_dropdown_text": "{first} — {last} de {totalRecords}",
  "thursday": "Quinta-feira",
  "toggle_off": "Desativado",
  "toggle_on": "Ativado",
  "token_can_not_be_empty": "O token não pode estar vazio",
  "token_is_missing": "O token está em falta",
  "tuesday": "Terça-feira",
  "unlimited": "ilimitado",
  "upload_add_manually": "Adicionar manualmente",
  "upload_add_manually_description": "Copie e cole vários endereços de e-mail ou em massa na área abaixo, separados por uma linha final. Para se lembrar do motivo de ter adicionado os contactos e para o ajudar em pesquisas futuras, acrescente um motivo para suprimir estes endereços.",
  "upload_add_manually_placheholder": "e-mail1,e-mail2,e-mail3,e-mail4,e-mail5...",
  "upload_add_reason": "Insira um motivo para suprimir estes endereços.",
  "upload_allowed_files": "Os formatos de ficheiro permitidos são csv ou txt.",
  "upload_dd_here": "Arraste e solte o seu ficheiro aqui",
  "upload_import_from_file": "Importar de um ficheiro",
  "upload_import_from_file_description": "O ficheiro deve ser uma coluna que contenha todos os endereços de e-mail que pretende importar. Para se lembrar do motivo de ter adicionado os contactos e para o ajudar em pesquisas futuras, acrescente um motivo para suprimir estes endereços.",
  "warning_lang": "O painel em seu idioma estará disponível em breve. Enquanto isso, entre em contato com a equipe de suporte para retornar ao antigo.",
  "wednesday": "Quarta-feira",
  "whitelabel_agencyname": "Nome da agência",
  "whitelabel_companydetails": "Detalhes da empresa",
  "whitelabel_description": "Se abriu uma subconta e é revendedor oficial do turboSMTP, personalizar o produto com o seu logótipo e informação de empresa proporcionará aos clientes a sua experiência de marca.",
  "whitelabel_footer": "Rodapé da agência",
  "whitelabel_footer_description": "Insira o código HTML a ser exibido na página de rodapé.",
  "whitelabel_logo": "Logótipo da empresa",
  "whitelabel_logo_description": "Tamanho máximo de imagem permitido: 472 x 72 px",
  "whitelabel_reset_default_image": "Restaurar imagem padrão",
  "whitelabel_upload_image": "Carregar imagem",
  "whitelabel_upload_in_progress": "Carregamento em curso",
  "whitelabel_website": "Site da agência",
  "wrong_credentials_specified": "As credenciais especificadas estão incorretas.",
  "yes": "Sim",
  "missing_required_parameter_amount": "Por favor, insira a quantidade",
  "amount_should_be_integer": "A quantidade deve ser um número inteiro",
  "amount_should_not_be_less_than_15": "A quantidade não deve ser inferior a 15",
  "amount_should_not_be_higher_than_1800": "A quantidade não deve ser superior a 1800",
  "missing_settings_required": "Algumas configurações são necessárias antes de habilitá-las",
  "settings_apikeys_title": "Chaves API",
  "settings_apikeys_description": "As Chaves API são uma forma altamente segura de conectar serviços turboSMTP aos seus aplicativos. Você pode revogar o acesso a qualquer momento.",
  "settings_apikeys_slide_title": "Chaves API",
  "settings_apikeys_slide_description": "Gerencie suas Chaves API. Esta tabela mostra todas as suas Chaves API ativas. Você pode criar novas chaves ou excluir chaves existentes para revogar seu acesso.",
  "settings_apikeys_slide_empty_title": "Criar Chave API",
  "settings_apikeys_slide_empty_description": "As Chaves API são compostas por um Consumer Key e um Consumer Secret. São credenciais de software que permitem que um programa acesse sua conta turboSMTP sem usar seu nome de usuário e senha. Eles são altamente seguros e podem ser revogados a qualquer momento sem alterar as credenciais de acesso ao painel turboSMTP.",
  "settings_apikeys_slide_add": "Criar Chave API",
  "settings_apikeys_slide_add_description": "Escolha um nome de referência para sua Chave API.",
  "settings_apikeys_apikey_name": "Nome",
  "settings_apikeys_slide_label_info": "Este nome é apenas para referência. Você não precisará inserir o nome em seus aplicativos.",
  "settings_apikeys_apikey_key": "Consumer Key",
  "settings_apikeys_apikey_creationtime": "Data de criação",
  "settings_apikeys_apikey_name_label": "Nome da Chave API",
  "settings_apikeys_apikey_name_placeholder": "Insira o nome da sua Chave API",
  "settings_apikeys_apikey_revoke_alt": "Excluir e revogar",
  "settings_apikeys_apikey_confirm_revoke_label": "Excluir e revogar Chave API",
  "settings_apikeys_apikey_confirm_revoke_text": "Excluir Chave API \"{name}\"?<br>Isso revogará o acesso a todos os aplicativos que usam essa chave.",
  "settings_apikeys_apikey_confirm_revoke_confirm": "Confirmar",
  "settings_apikeys_apikey_confirm_revoke_cancel": "Cancelar",
  "settings_apikeys_apikey_revoked": "Chave API revogada com sucesso",
  "settings_apikeys_apikey_consumerkey_button_add": "Gerar Chave API",
  "settings_apikeys_apikey_new_success": "Chave API criada!",
  "settings_apikeys_apikey_consumer": "Consumer Key",
  "settings_apikeys_apikey_secret": "Consumer Secret",
  "settings_apikeys_apikey_new_security": "Este <strong>Consumer Secret</strong> só é mostrado aqui. <strong>Copie agora e salve-o em um local seguro</strong>. Se você perder esta chave, será necessário excluí-la e gerar uma nova",
  "settings_apikeys_ips_label": "Restrição de IP",
  "settings_apikeys_permissions_label": "Permissões de API",
  "settings_apikeys_permissions_description": "Escolha os serviços aos quais esta chave de API pode aceder.",
  "settings_apikeys_permission_send_smtp": "Envio SMTP",
  "settings_apikeys_permission_send_api": "Envio HTTP API",
  "settings_apikeys_permission_apis": "Estatísticas e APIs de gestão",
  "settings_apikeys_permissions_required": "Selecione pelo menos uma opção",
  "settings_apikeys_legacy_key_alert_message": "Atualizamos nossa <strong>autenticação SMTP</strong> para usar <strong>chaves de API</strong> em vez da senha da sua conta.<br>Para garantir uma transição tranquila, <strong>criamos uma chave de API especial</strong> para você que corresponde às suas credenciais antigas. Para maior segurança, recomendamos que você <strong>exclua esta chave e crie uma nova</strong> para usar nas suas configurações de SMTP.",
  "settings_apikeys_legacy_key_alert_link": "Mais informações",
  "settings_apikeys_apikey_new_security_copy_cta": "Copiar para área de transferência",
  "settings_apikeys_apikey_new_security_copied_success": "Copiado!",
  "settings_apikeys_apikey_new_security_error": "Falha ao copiar",
  "settings_apikeys_action_regenerate_secret": "Gerar novo Consumer Secret",
  "settings_apikeys_action_regenerate_secret_confirmation_message": "Ao gerar um novo Consumer Secret, todo o código que usa a chave existente deixará de funcionar.",
  "settings_apikeys_action_regenerate_secret_confirmation": "Entendo, gerar novo Consumer Secret",
  "settings_apikeys_action_regenerate_secret_success": "Novo Consumer Secret gerado!",
  "settings_apikeys_allowed_ips": "IPs permitidos:",
  "settings_bccs_missing_required": "Certifique-se de definir um BCC como padrão antes de habilitá-lo",
  "settings_bccs_notifications_default": "O email padrão do BCC foi atualizado com sucesso",
  "settings_link_branding_enable": "Ative para usar seu próprio domínio de rastreamento",
  "settings_link_branding_missing_required": "Adicione e verifique pelo menos um domínio antes de ativar",
  "settings_link_branding_title": "Domínios de Rastreamento Personalizados",
  "settings_link_branding_description": "Use seus próprios domínios para rastreamento de aberturas e cliques, em vez daqueles incluídos pelo turboSMTP",
  "settings_link_branding_box_alert": "Essas configurações não terão efeito se o Rastreamento de Aberturas e o Rastreamento de cliques estiverem desativados.",
  "settings_link_branding_empty_description": "Clique em \"Adicionar Domínio\" e preencha os campos solicitados...",
  "settings_link_branding_empty_title": "Adicionar Domínio de Rastreamento",
  "settings_link_branding_add_domain": "Adicionar Domínio de Rastreamento",
  "settings_link_branding_add_domain_info": "Insira seu domínio e edite algumas configurações adicionais.",
  "settings_link_branding_advanced": "Opções avançadas",
  "settings_link_branding_custom_subdomain": "Subdomínio personalizado",
  "settings_link_branding_custom_subdomain_tooltip": "Por favor adicione um nome de domínio válido antes de especificar um subdomínio personalizado",
  "settings_link_branding_custom_subdomain_info": "O sistema irá gerar um subdomínio aleatório. Se você quiser usar um específico, insira-o aqui.",
  "settings_link_branding_button_add": "Adicionar Domínio de Rastreamento",
  "settings_link_branding_match": "Fazer corresponder o domínio de rastreamento com o domínio do remetente",
  "settings_link_branding_match_sender_disabled": "Domínios correspondentes desativados",
  "settings_link_branding_match_sender_enabled": "Domínios correspondentes ativados",
  "settings_link_branding_filters_no_results": "Nenhum resultado foi encontrado com esses filtros.",
  "settings_link_branding_search_placeholder": "Filtrar domínios de rastreamento por nome...",
  "settings_link_branding_verification_placeholder": "Validação...",
  "settings_link_branding_verified": "Verificado",
  "settings_link_branding_click_to_verify": "PENDENTE. A configuração CNAME deste domínio não foi concluída ou verificada. Clique para continuar...",
  "settings_link_branding_verification_success": "Verificação bem-sucedida",
  "settings_link_branding_verification_domain_not_found": "Domínio não encontrado",
  "settings_link_branding_verification_cname_not_found": "O CNAME para subdomínio {track_dns} não encontrado",
  "settings_link_branding_verification_auth_cname_not_found": "O CNAME para subdomínio {auth_dns} não encontrado",
  "settings_link_branding_verification_multiple_cname_found": "Vários registros CNAME encontrados para o subdomínio {track_dns}",
  "settings_link_branding_verification_auth_multiple_cname_found": "Vários registros CNAME encontrados para o subdomínio {auth_dns}",
  "settings_link_branding_verification_incorrect_cname_target": "O CNAME do subdomínio {track_dns} tem um valor incorreto",
  "settings_link_branding_verification_auth_incorrect_cname_target": "O CNAME do subdomínio {auth_dns} tem um valor incorreto",
  "settings_link_branding_enabled": "Ativado",
  "settings_link_branding_disabled": "Desabilitado",
  "settings_link_branding_not_verified": "Pendente",
  "settings_link_branding_name": "Nome do domínio",
  "settings_link_branding_enabled_no": "Domínio de rastreamento desativado",
  "settings_link_branding_enabled_yes": "Domínio de rastreamento ativado",
  "settings_link_branding_default_enabled": "Domínio de rastreamento definido como Não dedicado",
  "settings_link_branding_default_disabled": "Domínio de rastreamento definido como Dedicado",
  "settings_link_branding_subdomain_name_invalid": "O subdomínio é inválido",
  "settings_link_branding_domain_name_invalid": "Nome de domínio inválido",
  "settings_link_branding_confirm_delete_label": "Excluir domínio de rastreamento",
  "settings_link_branding_confirm_delete_text": "Você realmente deseja excluir este domínio de rastreamento?",
  "invalid_domain_name": "Nome de domínio inválido",
  "settings_link_branding_exclusivity_placeholder": "É dedicado...",
  "settings_link_branding_exclusive": "Dedicado",
  "settings_link_branding_not_exclusive": "Não dedicado",
  "settings_link_branding_domain_name": "Domínio de Rastreamento",
  "settings_link_branding_domain_status": "Estado",
  "settings_link_branding_added": "Domínio adicionado com sucesso",
  "settings_link_branding_removed": "Domínio excluído com sucesso",
  "settings_link_branding_default_match_help": "Domínios dedicados são usados ​​apenas com domínios de remetente correspondentes. Eles nunca são usados ​​com domínios de remetentes diferentes.",
  "settings_link_branding_dns_info": "Você precisará adicionar os seguintes registros para concluir a configuração.",
  "settings_link_branding_ssl_verify": "Não podemos verificar se os seus domínios SSL estão configurados corretamente a partir do painel de controle. Se precisar de ajuda, por favor entre em contato com nossa equipe de suporte técnico.",
  "settings_link_branding_dns_wait": "As alterações nos registros DNS podem levar até 24 horas para entrar em vigor",
  "settings_link_branding_dns_info_host": "Por favor adicione esses dois registros à seção DNS da sua hospedagem.",
  "settings_link_branding_dns_type": "Tipo",
  "settings_link_branding_dns_host": "Host",
  "settings_link_branding_dns_host_help": "Algumas hospedagens DNS podem se referir a isso como \"Domínio\" ou \"Nome\"",
  "settings_link_branding_dns_value": "Valor",
  "settings_link_branding_dns_value_help": "Alguns hosts DNS podem se referir a isso como \"Dados\"",
  "settings_link_branding_dns_help": "Nao tenho certeza de como fazer isso?",
  "settings_link_branding_dns_help_link": "Veja a documentação",
  "settings_link_branding_dns_verification_tooltip": "Este registro CNAME é o mesmo para todos os subdomínios do domínio. Deve ser adicionado apenas uma vez: se já estiver presente, não há necessidade de adicioná-lo.",
  "settings_link_branding_verify_description": "Depois de adicionado, pressione Verificar.",
  "settings_link_branding_verify_button": "Verificar",
  "settings_link_branding_delete_info": "Você não precisa mais deste domínio de rastreamento?",
  "settings_link_branding_delete_button": "Excluir domínio de rastreamento",
  "settings_link_branding_security_placeholder": "Segurança...",
  "settings_link_branding_https": "HTTPS",
  "settings_link_branding_http": "HTTP",
  "settings_link_branding_button_ok": "Ok",
  "settings_link_branding_status_placeholder": "Estado...",
  "settings_link_branding_status_enabled_no": "Desabilitado",
  "settings_link_branding_status_enabled_yes": "Ativo",
  "settings_link_branding_all_domains_disabled": "Quando todos os domínios personalizados estiverem desativados ou em estado pendente, os domínios de rastreamento turboSMTP serão usados.",
  "settings_link_branding_no_default_domain": "Se você definir todos os links de rastreamento Ativos como dedicados, os remetentes com domínios desativados ou ausentes nesta lista usarão nossos links de rastreamento do turboSMTP.",
  "settings_link_branding_match_modal_cancel": "Cancelar",
  "settings_link_branding_match_modal_confirm": "Ok",
  "settings_link_branding_match_title": "Rotação de domínio",
  "settings_link_branding_match_change": "Mude este comportamento",
  "settings_link_branding_match_enabled_title": "Corresponder ao domínio do remetente",
  "settings_link_branding_match_disabled_title": "Não corresponder ao domínio do remetente",
  "settings_link_branding_match_enabled_info": "Se o domínio do remetente corresponder a um dos domínios de rastreamento ativos, esse domínio de rastreamento será usado.<br> Se o domínio do remetente não corresponder a nenhum domínio de rastreamento, um dos domínios de rastreamento ativos (exceto os \"Dedicados\") será usado aleatoriamente.",
  "settings_link_branding_match_disabled_info": "Todos os domínios de rastreamento ativos serão usados, independentemente do domínio do remetente.",
  "config_server_error": "O painel de controlo está em manutenção, tente novamente dentro de alguns minutos",
  "feature_not_available_for_active_plan": "Esta funcionalidade não está incluída em nenhum dos seus planos",
  "forgot_password_use_different_password": "Por favor, crie uma nova senha diferente das anteriores para melhorar a segurança da sua conta.",
  "m_getting_started": "Início",
  "settings_sender_title": "Verificação de Domínios de Remetente",
  "settings_sender_add_domain": "Adicionar Domínio",
  "settings_sender_description": "Para melhorar a entrega de seus e-mails, basta autenticar seus domínios de remetente com três registros essenciais de DNS.",
  "settings_sender_domains_empty": "Você ainda não tem domínios de remetente verificados.<br>Por favor, verifique seu primeiro domínio.",
  "settings_sender_if_unverified": "O que acontece se o domínio do remetente não estiver verificado?",
  "settings_sender_notify_label": "Notificar-me por e-mail se o domínio do remetente não estiver verificado",
  "settings_sender_notify_email_label": "E-mail",
  "settings_sender_notify_email_tip": "Se o campo estiver vazio, a notificação será enviada para o endereço de sua conta do turboSMTP.",
  "settings_sender_notify_email_error": "Por favor, insira um endereço de e-mail válido",
  "settings_sender_notify_email_placeholder": "Insira um endereço de e-mail...",
  "settings_sender_dns_title": "Como verificar seu domínio",
  "settings_sender_dns_description": "Para o nosso serviço SMTP, você precisa configurar os registros SPF e DKIM em seus domínios de remetente. Adicionar um registro DMARC também é obrigatório para melhorar a segurança e a entregabilidade dos seus e-mails.",
  "settings_sender_spf_title": "Registro SPF",
  "settings_sender_spf_description": "Por favor, proceda adicionando o registro TXT especificado ao domínio do remetente, escolhendo uma das duas alternativas a seguir:",
  "settings_sender_dkim_title": "Registro DKIM",
  "settings_sender_dkim_description": "Para o DKIM, adicione o registro TXT fornecido na configuração DNS do seu domínio, que contém a chave pública usada para verificar que os e-mails enviados do seu domínio são legítimos e não foram alterados durante o trânsito.",
  "settings_sender_dmarc_title": "Registro DMARC",
  "settings_sender_dmarc_description": "Complete o processo de autenticação dos seus e-mails adicionando o registro DMARC TXT no seu DNS, estabelecendo uma política sobre como os receptores de e-mail devem tratar as mensagens que não passarem nas verificações de SPF ou DKIM, fornecendo assim uma camada adicional de defesa contra práticas fraudulentas por e-mail.",
  "settings_sender_domain_added": "Domínio de remetente <strong>{domain}</strong> adicionado.",
  "settings_sender_domain": "Domínio de remetente",
  "settings_sender_domains_name": "Nome do domínio",
  "settings_sender_domains_action_verify": "Verificar",
  "settings_sender_domains_action_delete": "Remover",
  "settings_sender_domains_action_subaccount": "Subconta:",
  "settings_sender_action_delete_confirm_title": "Remover domínio",
  "settings_sender_action_delete_confirm_message": "Tem certeza de que deseja remover o domínio <strong>{domainName}</strong>?",
  "settings_sender_domain_description": "Especifique o domínio do remetente que deseja validar:",
  "settings_sender_verify_record": "Registro TXT",
  "settings_sender_verify_value": "Status",
  "settings_sender_verify_ok": "Ok",
  "settings_sender_dns_ask_admin": "Por favor, entre em contato com o administrador da sua conta para verificar o domínio. Esta ação é necessária e só pode ser realizada pelo titular principal da conta.",
  "settings_sender_verify_fail": "{type} não encontrado ou não configurado corretamente",
  "settings_sender_verified": "Seu domínio está configurado corretamente. Você pode enviar com segurança usando este remetente.",
  "settings_sender_dkim_domain_title": "Domínio DKIM",
  "settings_sender_dkim_value_title": "Valor DKIM",
  "settings_sender_dmarc_domain_title": "Domínio DMARC",
  "settings_sender_dmarc_value_title": "Valor DMARC",
  "settings_sender_domains_search_placeholder": "Filtrar domínios de remetente por nome...",
  "settings_sender_domains_status_placeholder": "Verificação...",
  "settings_sender_domains_status_verified": "Verificado",
  "settings_sender_domains_status_not_verified": "Não verificado",
  "settings_sender_domains_filters_no_results": "Nenhum resultado encontrado com esses filtros",
  "block_unverified_sender_title": "Bloquear domínios de remetente não verificados",
  "block_unverified_sender_modal_title": "Domínios de remetente não verificados",
  "block_unverified_sender_desc": "Se o domínio do remetente não estiver verificado, bloquear o envio de e-mails e notificar-me por e-mail",
  "block_unverified_sender_change": "Alterar este comportamento",
  "forward_as_received_title": "Enviar Sem Modificações",
  "forward_as_received_info": "Envie seus e-mails sem modificações, mesmo de domínios de remetente não verificados. Tenha em mente que isso provavelmente resultará em uma <strong>alta taxa de rejeição e baixa entregabilidade</strong>, pois seus e-mails podem ser marcados como spam, afetando a reputação do seu domínio.",
  "block_title": "Rejeitar e Descartar",
  "block_info": "Escolha esta opção para garantir que e-mails não sejam enviados de domínios de remetente não verificados. As mensagens que não passarem nas verificações de SPF, DKIM ou DMARC serão automaticamente excluídas para <strong>manter sua reputação de envio</strong> e prevenir o risco de serem marcadas como spam.",
  "fallback_to_turbo_title": "Re-encaminhamento do Remetente.",
  "fallback_to_turbo_info": "Opte por re-encaminhar usando um endereço do turboSMTP como remetente para e-mails de domínios de remetente não verificados. Isso pode melhorar a entregabilidade, embora a <strong>mudança no endereço do remetente possa ser percebida</strong> pelos destinatários em seus clientes de e-mail.",
  "notification_email_updated": "E-mail de notificação atualizado.",
  "notification_email_enabled": "E-mail de notificação habilitado.",
  "notification_email_disabled": "E-mail de notificação desabilitado.",
  "invalid_notification_email": "E-mail de notificação inválido",
  "settings_sender_domains_new_intro": "Insira as informações do novo domínio",
  "paginator_page": "Página",
  "paginator_of": "de",
  "no_records_found": "Registro DNS não encontrado. Certifique-se de que o registro esteja publicado corretamente e que a propagação esteja completa.",
  "invalid_record_found": "Um registro DNS foi encontrado, mas parece estar formatado incorretamente ou possui um valor inválido.",
  "too_many_dns_lookups": "O registro SPF inclui mais do que o limite permitido de 10 consultas DNS, o que pode causar problemas na entrega de e-mails.",
  "more_than_spf_entry_found": "Vários registros SPF foram detectados para o seu domínio. Apenas um único registro SPF é permitido por domínio.",
  "settings_sender_loading_domain_data": "Carregando os resultados da verificação do domínio...",
  "notice": "Aviso",
  "settings_sender_domains_no_option": "<p>Sua conta opera atualmente sob o \"modo padrão\", uma <strong>configuração antiga</strong> que reenvolve todos os emails de saída com o nosso endereço de email, independentemente das suas configurações de SPF, DKIM e DMARC.</p>\n<p>Para realçar a capacidade de entrega de emails, recomendamos fortemente que escolha uma das opções de fallback atualizadas disponíveis.</p>",
  "failed_to_get_a_aaaa_record": "Falha ao obter registros A / AAAA para {domain_name}",
  "invalid_spf_syntax": "Sintaxe SPF inválida",
  "spf_has_upper_case_letters": "O registro SPF não deve conter letras maiúsculas. Por favor, certifique-se de que todos os caracteres estão em minúsculas para cumprir com a especificação SPF.",
  "recursive_include_detected": "O seu registro SPF não deve incluir o próprio domínio, pois isso cria um loop, levando a buscas DNS infinitas. Por favor, revise o registro SPF para remover a referência ao domínio a fim de evitar dependências circulares e cumprir com a especificação SPF.",
  "spf_longer_than_255_characters": "O registro SPF excede o limite de 255 caracteres para uma única cadeia de texto DNS. Para aderir às especificações de DNS, por favor, divida seu registro SPF em várias cadeias, cada uma não excedendo 255 caracteres, ou encurte o registro para cumprir com o limite.",
  "ptr_mechanism_not_allowed": "Para otimizar o desempenho do SPF e promover a adoção de práticas robustas de verificação de remetentes, é aconselhável excluir o mecanismo ptr e confiar, em vez disso, em mecanismos como ip4 e include.",
  "data_location_modal_title": "Localização dos dados",
  "data_location_network_servers": "Servidores de rede",
  "data_location_ip_location": "Localização IP",
  "data_location_company_managing_data": "Empresa gestora dos dados",
  "data_location_network_servers_value": "Milão (IT), Frankfurt (DE), Amesterdão (NL)",
  "data_location_ip_location_value": "Europa RI.PE",
  "data_location_company_managing_data_value": "Edisplay Srl, Itália UE",
  "data_location_no_transfer_outside_eu": "Nenhum dado é transferido para fora da União Europeia",
  "gdpr_data_location": "Dados na UE",
  "gdpr_see_details": "Detalhes",
  "not_included_in_plan": "Não incluído no seu plano atual",
  "registration_logout": "Sair",
  "registration_step_personal": "Informações Pessoais",
  "registration_step_company": "Informações da Empresa",
  "registration_step_address": "Endereço",
  "registration_label_email": "E-mail",
  "registration_label_firstname": "Nome",
  "registration_label_lastname": "Sobrenome",
  "registration_label_company": "Empresa",
  "registration_label_vat": "Número de IVA",
  "registration_label_vat_optional": "(Opcional)",
  "registration_label_phone": "Número de Telefone",
  "registration_label_website": "Website",
  "registration_label_website_hint": "(Opcional)",
  "registration_label_address": "Endereço",
  "registration_label_city": "Cidade",
  "registration_label_country": "País",
  "registration_placeholder_country": "Selecione o País",
  "registration_label_region": "Estado / Região",
  "registration_placeholder_region": "Selecione a Região",
  "registration_label_zip": "Código Postal",
  "registration_btn_back": "Voltar",
  "registration_btn_next": "Próximo Passo",
  "registration_btn_complete": "Completar Perfil",
  "registration_error_firstname": "O nome é obrigatório.",
  "registration_error_lastname": "O sobrenome é obrigatório.",
  "registration_error_company": "A empresa é obrigatória.",
  "registration_error_phone": "O número de telefone é obrigatório.",
  "registration_error_website": "Por favor, insira uma URL válida.",
  "registration_error_address": "O endereço é obrigatório.",
  "registration_error_city": "A cidade é obrigatória.",
  "registration_error_country": "O país é obrigatório.",
  "registration_error_region": "A região é obrigatória.",
  "registration_error_zip": "O código postal é obrigatório.",
  "registration_error_phone_format": "O número de telefone deve conter apenas números.",
  "registration_address_message": "Ao garantir que seu endereço postal esteja correto, você pode se beneficiar de uma <strong>experiência de ativação acelerada</strong>.",
  "registration_step_confirmation": "Confirmação",
  "registration_confirmation_title": "Perfil concluído!",
  "registration_confirmation_message": "A sua conta foi criada com sucesso.<br>Agora pode adquirir um plano para desbloquear funcionalidades avançadas e limites de envio mais elevados",
  "registration_confirmation_message_buy": "A sua conta foi criada com sucesso.",
  "registration_btn_buy_plan": "Comprar um plano",
  "registration_stay_free": "Manter a versão gratuita, poderá fazer upgrade mais tarde",
  "registration_btn_dashboard": "Ir para o Painel",
  "registration_redirect_to_shop": "Será redirecionado para o processo de pagamento em breve...",
  "registration_go_to_shop": "Clique aqui para prosseguir para o pagamento",
  "button_yes_delete": "Sim, eliminar",
  "button_yes_revoke": "Sim, revogar"
}
